import React from 'react';
import { Container, Navbar, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';
import logo from '../img/app-icon-without-background.png';
import { logout, loyaltyOffersSession, roleAdministrator, roleAgent, roleMerchantAdministrator, userRoleHeader, getSessionValue, posIntegration, cssTextDark, enabledContactRequestHeader } from './Library'
import { BusinessSelector } from './BusinessSelector';
import { InternalReviewLink } from './InternalReviews';
import { enc } from 'crypto-js';

export function NavMenu() {

    let loyaltyOfferLink;
    let messageLink;
    let voucherLink;
    let additionalMatchesLink;
    let requestReviewsLink;
    let internalReviewsLink;
    let addBusinessLink;
    let addRegisteredUsersLink;
    let registerAndAddUsersLink;
    let disableUsersLink;
    let contactRequestsLink;

    if (getSessionValue(loyaltyOffersSession) != null && getSessionValue(loyaltyOffersSession).length > 0) {
        additionalMatchesLink = <NavItem>
            <NavLink tag={Link} className="text-dark" to="/">{posIntegration ? "Transfer Points from Existing Cards" : "Generate Scan Code"}</NavLink>
        </NavItem>
    }

    let userRole = JSON.parse(sessionStorage.getItem(userRoleHeader));
    let enabledContactRequests = JSON.parse(sessionStorage.getItem(enabledContactRequestHeader));

    if (userRole == roleAdministrator || userRole == roleAgent) {
        addBusinessLink = <NavItem>
            <NavLink tag={Link} className="text-dark" to="/business">Add New Business</NavLink></NavItem>
    }

    if (userRole == roleAdministrator || userRole == roleAgent || userRole == roleMerchantAdministrator) {
        loyaltyOfferLink = <NavItem>
            <NavLink tag={Link} className="text-dark" to="/loyaltyoffer">Loyalty Offer</NavLink>
        </NavItem>;
        messageLink = <NavItem>
            <NavLink tag={Link} className="text-dark" to="/message">Message</NavLink>
        </NavItem>;
        voucherLink = <NavItem>
            <NavLink tag={Link} className="text-dark" to="/voucher">Voucher</NavLink>
        </NavItem>;
        requestReviewsLink = <NavItem>
            <NavLink tag={Link} className="text-dark" to="/reviewrequesttemplate">Request Reviews</NavLink>
        </NavItem>;
        internalReviewsLink = <InternalReviewLink/>
        addRegisteredUsersLink = posIntegration ? '' : <NavItem>
            <NavLink tag={Link} className={cssTextDark} to="/addexistinguser">Add Registered User to Business</NavLink></NavItem>;
        registerAndAddUsersLink = posIntegration ? '' : <NavItem><NavLink tag={Link} className={cssTextDark} to="/addnewuser">Register and Add User to Business</NavLink></NavItem>
        disableUsersLink = posIntegration ? '' : <NavItem><NavLink tag={Link} className={cssTextDark} to="/disableusers">Disable Users</NavLink></NavItem>
        contactRequestsLink = enabledContactRequests ? <NavItem><NavLink tag={Link} className={cssTextDark} to="/contactrequests">Contact Requests</NavLink></NavItem> : ''
    }

    return (
        <header>
        <BusinessSelector/>
            <Navbar className="navbar" light>
                <Container>
                    <img className="logo" src={logo} alt="Receipts and Rewards Logo" width="58px" height='58px' />
                    <ul className="navbar-nav flex-grow">
                        {loyaltyOfferLink}
                        {messageLink}
                        {voucherLink}
                        {contactRequestsLink }
                        {additionalMatchesLink}
                        {requestReviewsLink}
                        {internalReviewsLink}
                        { posIntegration ? <NavItem>
                            <NavLink tag={Link} className="text-dark" to="/receiptsforbusiness">Receipt History</NavLink>
                        </NavItem> : '' }
                        {posIntegration ? <NavItem>
                            <NavLink tag={Link} className="text-dark" to="/tills">QR Codes for Tills</NavLink>
                        </NavItem> : ''}
                        {posIntegration ? '' : <NavItem>
                            <NavLink tag={Link} className="text-dark" to="/loyaltyoffers">QR Codes for Loyalty Offers</NavLink>
                        </NavItem>}
                        {addBusinessLink}
                        {registerAndAddUsersLink}
                        {disableUsersLink }
                    </ul>

                    <button onClick={logout} className='form-input-button'>Logoff</button>
                </Container>
            </Navbar>
        </header>
    );
}
